/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable  @typescript-eslint/no-unused-vars */
/* eslint-disable  @typescript-eslint/consistent-indexed-object-style */
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';
import { forkJoin, Observable, BehaviorSubject, firstValueFrom } from 'rxjs';
import moment from 'moment';

@Injectable({
	providedIn: 'root'
})
export class ApiService {
	constructor(private httpClient: HttpClient, private router: Router) { }

	public API_URL = environment.API_URL;
	public LOGIN_API_URL = environment.LOGIN_API_URL;

	private userDataSubject = new BehaviorSubject<any>(null);
	userData$ = this.userDataSubject.asObservable();
	setUserData(data: any): void {
		this.userDataSubject.next(data);
	}

	private userListSubject = new BehaviorSubject<any>(null);
	userList$ = this.userListSubject.asObservable();
	setUserList(data: any): void {
		this.userListSubject.next(data);
	}

	getDateStringFromDate(date: any, format: string): string | null {
		if (!date) {
			return null;
		}
		if (typeof date === 'string' || typeof date === 'number') {
			date = new Date(date);
		}
		if (!(date instanceof Date) || isNaN(date.getTime())) {
			return null;
		}
		const formattedDate = moment(date).format(format);
		return formattedDate;
	}

	getDateFromDateString(date: any, format: string) {
		if (date == "" || date == null || date == undefined) {
			return null;
		}
		date = moment(date, format);
		if (date.isValid()) {
			return date.toDate();
		} else {
			return null;
		}
	}

	getTimeFromTimeString(timeStr: string) {
		if (!timeStr) {
			return null;
		}
		let arr = timeStr.split(":");
		return { hour: parseInt(arr[0]), minute: parseInt(arr[1]), second: 0 };
	}

	getTimeStringFromTime(dateObj: any) {
		if (dateObj == "" || dateObj == null || dateObj == undefined) {
			return null;
		}
		let hour = dateObj.hour + "";
		let minutes = dateObj.minute + "";
		let seconds = dateObj.second + "";
		hour = this.checkZero(hour);
		minutes = this.checkZero(minutes);
		seconds = this.checkZero(seconds);
		return hour + ":" + minutes + ":" + seconds;
	}

	checkZero(data: any) {
		if (data != undefined && data.toString().length == 1) {
			data = "0" + data;
		}
		return data;
	}

	public getVesselsFromLocalStorage() {
		try {
			let vessels: any = JSON.parse(localStorage.getItem("vessel_ids")!);
			return vessels;
		} catch (error) {
			return [];
		}
	}

	public getHomeURL() {
		let endpoint = "/vessels";
		let vessels = this.getVesselsFromLocalStorage();
		if (vessels.length == 1) {
			endpoint = "/dashboard/" + vessels[0];
		}
		return "/" + this.getNavbar() + endpoint;
	}

	public getNavbar() {
		return "app";
	}

	navigateToLogin(storeState: boolean) {
		localStorage.clear();
		if (storeState) {
			this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.routerState.snapshot.url } });
		} else {
			this.router.navigate(['/login']);
		}
	}

	public loginAPI(user: any) {
		return this.httpClient.post(this.LOGIN_API_URL + "login", user);
	}

	public sendResetPasswordLink(data: any) {
		return this.httpClient.post(this.API_URL + "api/sendResetPasswordLink/", data);
	}

	public setNewPassowrd(data: any) {
		return this.httpClient.post(this.API_URL + "api/setPassowrd/", data);
	}

	public checkLinkExpiry(data: any) {
		return this.httpClient.post(this.API_URL + "api/checkLinkExpiry/", data);
	}

	public resetPassword(data: any) {
		return this.httpClient.post(this.API_URL + "api/set_password", data);
	}

	public reset2fa(data: any) {
		return this.httpClient.post(this.API_URL + "api/reset2fa", data);
	}

	public generate_qr(data: any) {
		return this.httpClient.post(this.API_URL + "api/generate_qr", data, { responseType: "blob" });
	}

	public verifyGoogleAuthOTP(params: any) {
		const httpParams: HttpParamsOptions = { fromObject: params } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.API_URL + "api/verify_otp", options);
	}

	public getUserAccess() {
		return this.httpClient.get(this.API_URL + "api/user_details");
	}

	public getVesselInventory(data: any) {
		return this.httpClient.post(this.API_URL + "vessel/get_vessel_inventory", data);
	}

	public getConsumptionLogs(params: any) {
		const httpParams: HttpParamsOptions = { fromObject: params } as HttpParamsOptions;
		const options = { params: new HttpParams(httpParams) };
		return this.httpClient.get(this.API_URL + "vessel/get_consumption_logs", options);
	}

	public vesselInventryExcelDownloadOld(data: any) {
		return this.httpClient.post(this.API_URL + "vessel/download_vessel_inventory", data, { observe: 'response', responseType: 'arraybuffer' });
	}

	public vesselInventryExcelDownload(data: any) {
		return this.httpClient.post(this.API_URL + "vessel/download_vessel_inventory", data, { observe: 'response', responseType: 'text' });
	}

	public getVesselDetails(data: any) {
		return this.httpClient.post(this.API_URL + "vessel/get_vessels", data);
	}

	public MedicineBrandQtyExpList(data: any) {
		return this.httpClient.post(this.API_URL + "vessel/get_inventory_batches", data);
	}

	public consumptionLogTracking(data: any) {
		return this.httpClient.post(this.API_URL + "vessel/update_inventory_batch", data);
	}

	public addInventoryBatch(data: any) {
		return this.httpClient.post(this.API_URL + "vessel/add_inventory_batch", data);
	}
}

export interface HttpParamsOptions {
	fromString?: string;
	fromObject?: {
		[param: string]: string | string[];
	};
	encoder?: HttpParameterCodec;
}

interface HttpParameterCodec {
	encodeKey(key: string): string
	encodeValue(value: string): string
	decodeKey(key: string): string
	decodeValue(value: string): string
}